'use client';

import { Skeleton } from '@/components/Skeleton';
import { useDevice } from '@/hooks/device';

import { ScContainer } from '@/styles/common';

export default function GeneralSkeleton() {
  const { isMobileDevice } = useDevice();

  return (
    <ScContainer>
      <Skeleton.Container marginBottom={24}>
        <Skeleton.Rect height={400} />
      </Skeleton.Container>
      <Skeleton.Container
        flexDirection={isMobileDevice ? 'column' : 'row'}
        gap={16}
        justifyContent="space-between"
        marginBottom={24}
      >
        <Skeleton.Container flexDirection="column" gap={8}>
          <Skeleton.Rect height={40} />
          <Skeleton.Rect height={200} />
        </Skeleton.Container>
        <Skeleton.Container flexDirection="column" gap={8}>
          <Skeleton.Rect height={40} />
          <Skeleton.Rect height={200} />
        </Skeleton.Container>
        <Skeleton.Container flexDirection="column" gap={8}>
          <Skeleton.Rect height={40} />
          <Skeleton.Rect height={200} />
        </Skeleton.Container>
      </Skeleton.Container>
    </ScContainer>
  );
}
